class Suspense extends Element {
    props = {
        minHeight: "15.25rem"
    }

    _targetElement
    _skeleton

    setup(props) {
        this.$el.css("min-height", props.minHeight)

        this._skeleton = this.$el.find("skeleton-loader");

        this._targetElement = this.$el.children().filter(function () {
            return this.localName !== "skeleton-loader"
        }).first();

        this._targetElement.css("opacity", 0);
    }

    beforeMount() {
        this.addEventListener('suspense-ready', this.stop.bind(this));
    }

    stop() {
        requestAnimationFrame(() => {
            setTimeout(() => {
                this._targetElement.css("opacity", 1)
                this._skeleton.remove();
            }, 250)
        });
        // this.$el.replaceWith(this._targetElement);

    }
}


if (!customElements.get("base-suspense")) {
    customElements.define("base-suspense", Suspense);
}
